const APIS = {
  PICKUPREQUEST: "/pickuprequestservice/api/pickup-request/",
  BRANCH: "/logisticservice/api/branch/",
  DRIVER: "/fleetservice/api/driver/",
  DRIVER_CREATE: "/fleetservice/api/driver/create-rider/",
  VEHICLE: "fleetservice/api/vehicle/",
  PICKUPREQUEST_ITEMS: "/pickuprequestservice/api/pickup-request-item/",
  STATUS: "/logisticservice/api/status/",
  ORDER: "/logisticservice/api/order/",
  MERCHANT: "/logisticservice/api/merchant/",
  PICKUPREQUEST_STATUS: "/pickuprequestservice/api/pickup-request-settings/",
  USER: "/usermanagementservice/api/user/",
  RTV_ORDER: "/rtvorderservice/api/rtv-order",
  RTV_ORDER_ITEMS: "/rtvorderservice",
  COMMENT: "/commentservice/api/comment/",
  VEHICLE_MANIFEST_ITEMS: "/vehiclemanifestservice/api/vehicle-manifest-item/",
  PICKUP_NOTES: "logisticservice/api/pickup-note/",
  DELIVERY_PARTNER: "/deliveryservice/api/delivery-partner-configurations/",
  TAX_INVOICE: "invoiceservice/api/tax-invoice/",
  ASSIGN_DELIVERY: "/deliveryservice/api/order/assign-delivery/",
  EXCELDOWNLOAD: "/logisticservice/api/order/email-order-excel/",
  DELIVERY_STATUS: "/logisticservice/api/delivery-settings/",
  DELIVERY: "/vehiclemanifestservice/api/vehicle-manifest/delivery/",
  SUB_ORDER: "/logisticservice/api/sub-order/",
};

export default APIS;

